export const STATIC_URL = {
  TITLE_BACKGROUND:
    "https://user-images.githubusercontent.com/52532871/94314172-f9502300-ffba-11ea-9da3-3fb7ff26e892.png",
  STAR_BACKGROUND:
    "https://user-images.githubusercontent.com/52532871/94320344-acbf1480-ffc7-11ea-9e52-a79ccbc52ae1.png",
  TOKKI_IMG: "https://user-images.githubusercontent.com/52532871/94315699-fc98de00-ffbd-11ea-8571-13e65fa666fb.gif",
  REACT_GIF: "https://user-images.githubusercontent.com/52532871/94317841-16d4bb00-ffc2-11ea-94a6-675ae59604bc.gif",
  REACT_IMG: "https://user-images.githubusercontent.com/52532871/94317843-176d5180-ffc2-11ea-99cb-ecf741b8db50.png",
  C_IMG: "https://user-images.githubusercontent.com/52532871/94317524-839b8580-ffc1-11ea-86e0-e4129438a9be.png",
  UNITY_IMG1: "https://user-images.githubusercontent.com/52532871/94318193-ea6d6e80-ffc2-11ea-91ec-a42b3b6e2ada.png",
  UNITY_IMG2: "https://user-images.githubusercontent.com/52532871/94318191-e9d4d800-ffc2-11ea-9c37-f00a8d31c553.png",
  REACT_NAME: "https://user-images.githubusercontent.com/52532871/94318877-6f0cbc80-ffc4-11ea-93e0-f77a16bebdb2.png",
  C_NAME: "https://user-images.githubusercontent.com/52532871/94318882-6fa55300-ffc4-11ea-8eb6-fffab69cd107.png",
  UNITY_NAME: "https://user-images.githubusercontent.com/52532871/94318880-6fa55300-ffc4-11ea-831e-1d5bb1299a19.png",
};

export const BREAKPOINT = 640;
